import * as web3 from '@solana/web3.js';

export const FIRST_CREATOR_IS_LAST_INDEX = false ;//false; // change to false for mainnet as it's the first index 
                                                // instead of last


export const NETWORK = "mainnet-beta";

export const programId : web3.PublicKey = 

new web3.PublicKey("Gt57EmeCqsmodrn5uX6nvPyaridoRiXGubedniyZrdKW");

// for $DAWG token 
export const DC_TOKEN_DECIMAL = 4; 

export const DC_TOKEN_MINT = "GmY2Rp9t5S4yD5jhgJrc47VSAa6hQiikkYi3sr9HLNZr";

//"9QKHcZihXMdBgYdrWgqXCP6o6GWWb9ttsqS7WXSVuJZ8";

// This is the wallet address that created the $DAWG token vault
export const DC_TOKEN_VAULT_OWNER = "gDqyKztPYkruHnHYBUsAVotzL51vmj8onCdUbri43nJ";


// NFT token vault API URI
export const NFT_TOKEN_VAULT_API = "https://mphayc-staking-ui.vercel.app/api/tokenvault?mint=";

export const NFT_TOKEN_VAULT_FILE_WALLET = "8jhDtR5W5Xjzde1cZtBuDcF7CLPR7DMqzFPheQw9sYJx";

export const STAKE_DATA_API = "https://mphayc-staking-ui.vercel.app/api/stakeData";


export const SIGN_IN_API = "https://mphayc-staking-ui.vercel.app/api/signin";


export const SIGN_OUT_API = "https://mphayc-staking-ui.vercel.app/api/signout";

// for DC NFT 
export const DC_UPDATE_AUTHORITY = "DoMmBKB8X8dxoYSLEx1Zuie8bzX2V5gz5FpJ6TXujqwS";

export const DC_VALID_FIRST_CREATOR = "";
